/* eslint-disable eqeqeq */
/* eslint-disable no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/img-redundant-alt */
import Table from "../../extras/Table";
import Button from "../../extras/Button";
import Pagination from "../../extras/Pagination";
import Title from "../../extras/Title";

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  expertDelete,
  getAllExpert,
  blockExpert,
} from "../../../redux/slice/expertSlice";
import { openDialog } from "../../../redux/slice/dialogueSlice";
import { ExpertDialogue } from "./ExpertDialogue";
import {
  permissionError,
  permissionErrorForDemo,
  warning,
} from "../../../util/Alert";
import ToggleSwitch from "../../extras/ToggleSwitch";
// import { Dummy } from "./Dummy";
import { useNavigate } from "react-router-dom";
import Searching from "../../extras/Searching";
import Male from "../../../assets/images/male.png";
import NotificationDialog from "../User/NotificationDialog";
import { getAllSalons } from "../../../redux/slice/salonSlice";
import { ReactComponent as Delete } from "../../../assets/icon/delete.svg";
import { IconBell, IconClockCheck, IconInfoCircle, IconMoneybag, IconNotification, IconTrash } from "@tabler/icons-react";
import LazyImage from "../../extras/ImageFallback";

export const Expert = () => {
  const [data, setData] = useState([]);

  const { expert, total } = useSelector((state) => state.expert);
  const { salon } = useSelector((state) => state.salon);

  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.auth.admin.flag);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [salonId, setSalonId] = useState("ALL");
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event, 10));
    setPage(0);
  };

  const handleFilterData = (filteredData) => {
    if (typeof filteredData === "string") {
      setSearch(filteredData);
    } else {
      setData(filteredData);
    }
  };

  useEffect(() => {
    const payload = {
      start: page,
      limit: rowsPerPage,
      search,
      salonId: salonId,
    };
    dispatch(getAllExpert(payload));
    dispatch(getAllSalons(payload));
  }, [page, rowsPerPage, search]);

  useEffect(() => {
    setData(expert);
  }, [expert]);

  function openImage(imageUrl) {
    // Open the image in a new tab or window
    window.open(imageUrl, "_blank");
  }

  const handleInfo = (id) => {
    navigate("/admin/expert/getExpertProfile", {
      state: {
        id,
      },
    });
  };

  const expertTable = [
    {
      Header: "No",
      Cell: ({ index }) => (
        <span>{page * rowsPerPage + parseInt(index) + 1}</span>
      ),
    },
    {
      Header: "Image",
      Cell: ({ row }) => (
        <div className="userProfile">
          <LazyImage
            src={row && row.image ? row.image : Male}
            style={{ height: "50px", width: "50px", overflow: "hidden" }}
            alt="image"
            className="cursor-pointer"
            onClick={() => handleInfo(row._id)}
            height={`100%`}
            onError={(e) => {
              e.target.src = Male;
            }}
          />
        </div>
      ),
    },
    {
      Header: "Name",
      Cell: ({ row }) => (
        <span
          className="text-capitalize  cursor"
          onClick={() => handleInfo(row._id)}
        >
          {row?.fname ? row?.fname + " " + row?.lname : "Salon User"}
        </span>
      ),
    },
    {
      Header: "Email",
      Cell: ({ row }) => <span>{row?.email}</span>,
    },
    {
      Header: "Salon",
      Cell: ({ row }) => <span>{row?.salon ? row?.salon : "-"}</span>,
    },
    {
      Header: "Age",
      body: "age",
      Cell: ({ row }) => <span>{row?.age}</span>,
      sorting: { type: "client" },
    },
    {
      Header: "Gender",
      Cell: ({ row }) => <span className="text-capitalize">{row?.gender}</span>,
    },
    {
      Header: "Commission",
      body: "commission",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <span className="text-capitalize ">{row?.commission + " %"}</span>
      ),
    },
    {
      Header: "Block",
      body: "isBlock",
      sorting: { type: "client" },
      Cell: ({ row }) => (
        <ToggleSwitch
          value={row?.isBlock}
          onClick={() => {
            if (row?._id === "6617c9ced03f8d115d62b90d")
              return permissionError();
            if (!hasPermission) return permissionError();
            dispatch(blockExpert(row?._id));
          }}
        />
      ),
    },
    {
      Header: "Booking",
      body: "booking",
      Cell: ({ row }) => (
        <div className="action-button">

        <button
          className="btn btn-sm"
          onClick={() => handleOpenBookings(row)}
        >
          <IconClockCheck className="text-secondary" />
        </button>
        </div>
      ),
    },
    {
      Header: "Earnings",
      Cell: ({ row }) => (
         <div className="action-button">
          <button
            className="btn btn-sm"
            onClick={() => handleEarning(row)}
          >
             <IconMoneybag className="text-secondary" />
          </button>
        </div>
      ),
    },
    // {
    //   Header: "Info",
    //   Cell: ({ row }) => (
    //     <div className="action-button">
    //       <button
    //         className="btn btn-sm"
    //         onClick={() => handleInfo(row._id)}
    //       >
    //        <IconInfoCircle className="text-secondary" />
    //       </button>
    //     </div>
    //   ),
    // },
        {
      Header: "Notification",
      Cell: ({ row }) => (
         <div className="action-button">
          <button
             className="btn btn-sm"
            onClick={() => handleNotify(row._id)}
          >
            <IconBell className="text-secondary"  />
          </button>
        </div>
      ),
    },
    {
      Header: "Action",
      Cell: ({ row }) => (
       <div className="action-button">
        <button
            className="btn btn-sm"
            onClick={() => handleInfo(row._id)}
          >
           <IconInfoCircle className="text-secondary" />
          </button>
          <button
           className="btn btn-sm"
            onClick={() => handleDelete(row?._id)}
          >
            <IconTrash className="text-secondary"  />
          </button>

        </div>
      ),
    },

  ];

  const handleNotify = (id) => {
    if (id === "6617c9ced03f8d115d62b90d") return permissionError();
    if (!hasPermission) return permissionError();
    dispatch(
      openDialog({ type: "notification", data: { id, type: "expert" } })
    );
  };

  const handleDelete = async (id) => {
    if (!hasPermission) return permissionError();
    if (id === "6842d75618181364fb76859e")
      return permissionErrorForDemo("Expert");
    try {
      const data = await warning("Delete");
      const yes = data.isConfirmed;
      console.log("yes", yes);
      if (yes) {
        dispatch(expertDelete(id));
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleAddExpert = (row) => {
    navigate("/admin/expert/addExpert", {
      state: {
        row,
      },
    });
  };

  const handleOpenBookings = (row) => {
    navigate("/admin/expert/bookings", { state: { data: row } });
  };

  const handleEarning = (row) => {
    navigate("/admin/particularExpert/income", {
      state: {
        row,
      },
    });
  };

  return (
    <div className="userPage">
      <div className="user-table mb-3">
        <div className="user-table-top">
          <div className=" d-flex justify-content-between align-items-center w-100 ">
            <div className="w-100">
              <h5 className="main-title">Experts</h5>
            </div>
            <div className="d-flex gap-2 justify-content-end w-100">
            <Searching
              type={`server`}
              data={data}
              setData={setData}
              column={expertTable}
              serverSearching={handleFilterData}
            />
              <div className="inputData mb-0">
                <select
                  name="bookingType"
                  className="form-select"
                  id="bookingType"
                  value={salonId}
                  onChange={(e) => {
                    const selectedSalonId = e.target.value;
                    let payload = {
                      salonId: selectedSalonId,
                      search: "ALL",
                    };
                    setSalonId(selectedSalonId);
                    dispatch(getAllExpert(payload)); // Dispatch action with selected salon ID
                  }}
                >
                  <option key="ALL" value="ALL">
                    ALL
                  </option>
                  {salon.map((data) => (
                    <option key={data._id} value={data._id}>
                      {data.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* <Title name="Experts" /> */}

        {/* <div className="betBox"> */}
          

          {/* <Button
          className={`bg-button m20-left p-10 mt-5 text-white`}
          text={`Add Expert`}
          style={{padding: "9px 20px"}}
          bIcon={`fa-solid fa-user-plus`}
          onClick={() => handleAddExpert()}
        /> */}

          {/* <div className="col-md-8 col-lg-5  ms-auto m45-top">
            <Searching
              type={`server`}
              data={data}
              setData={setData}
              column={expertTable}
              serverSearching={handleFilterData}
            />
          </div> */}
        {/* </div> */}

        
        <div>
          <Table
            data={data}
            mapData={expertTable}
            serverPerPage={rowsPerPage}
            Page={page}
          />
          <Pagination
            type={"server"}
            serverPage={page}
            setServerPage={setPage}
            serverPerPage={rowsPerPage}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            totalData={total}
          />
        </div>
      </div>
    </div>
  );
};
